import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 2.5rem;
  background: #4B0000;
  box-shadow: 0 2px 16px rgba(139, 0, 0, 0.3);
  position: sticky;
  top: 0;
  z-index: 999;
  will-change: transform;
  transition: background-color 0.3s ease;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  
  a {
    display: flex;
    align-items: center;
    font-size: 2.2rem;
    color: #FF8C00;
    text-decoration: none;
    transition: color 0.2s;
    
    &:hover {
      color: #FFD700;
    }
  }
  
  h1 {
    font-size: 1.7rem;
    font-weight: 700;
    color: #FFD700;
    letter-spacing: 1px;
    margin: 0;
  }
`;

const NavMenu = styled.nav`
  ul {
    display: flex;
    list-style: none;
    gap: 3rem;
  }
`;

const NavLink = styled.a`
  color: #FFFFE0;
  font-weight: 500;
  position: relative;
  padding: 0.5rem 0.2rem;
  letter-spacing: 0.5px;
  transition: color var(--transition-speed) var(--transition-effect);
  
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 3px;
    background: #FFD700;
    border-radius: 2px;
    transition: width var(--transition-speed) var(--transition-effect);
    box-shadow: 0 0 8px rgba(255, 215, 0, 0.5);
  }
  
  &:hover, &.active {
    color: #FFD700;
  }
  
  &:hover::after, &.active::after {
    width: 100%;
  }
`;

// Add the missing SocialNav styled component
const SocialNav = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const SocialIcon = styled.a`
  font-size: 1.4rem;
  color: #FFFFE0;
  transition: color var(--transition-speed-fast) var(--transition-effect),
              transform var(--transition-speed-fast) var(--transition-effect);
              
  &:hover {
    color: #FFD700;
    transform: scale(1.2) translateY(-2px);
  }
`;

const MenuButton = styled.button`
  display: none;
  cursor: pointer;
  font-size: 1.8rem;
  color: var(--heading-text);
  background: none;
  border: none;
  padding: 5px;
  z-index: 102;
  transition: color var(--transition-speed) var(--transition-effect);
  
  &:hover {
    color: var(--accent-color);
  }
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <HeaderContainer role="banner" style={{ 
      backgroundColor: scrolled ? 'var(--header-scrolled-bg)' : 'var(--header-bg)'
    }}>
      <Logo>
        <a href="#home">
          <i className="bx bx-joystick"></i>
        </a>
        <h1>RAKSHIT</h1>
      </Logo>
      
      <NavMenu className={menuOpen ? 'active' : ''}>
        <ul>
          <li><NavLink href="#home" className="active">Home</NavLink></li>
          <li><NavLink href="#projects">Projects</NavLink></li>
          <li><NavLink href="#skills">Skills</NavLink></li>
          <li><NavLink href="#contact">Contact</NavLink></li>
        </ul>
      </NavMenu>
      
      <SocialNav>
        <SocialIcon href="https://github.com" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-github"></i>
        </SocialIcon>
        <SocialIcon href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin"></i>
        </SocialIcon>
        <SocialIcon href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter"></i>
        </SocialIcon>
      </SocialNav>
      
      <MenuButton onClick={() => setMenuOpen(!menuOpen)}>
        <i className={menuOpen ? 'bx bx-x' : 'bx bx-menu'}></i>
      </MenuButton>
    </HeaderContainer>
  );
};

export default Header;